import { TaggedError } from "@for-it/domain-lib";
export class DniInUseError extends TaggedError {
    constructor() {
        super("DniInUseError");
    }
}
